export default {
  titleConfirm: 'Enter a verification code',
  titleVerify: 'Verify your email',
  subtitle1Confirm: 'We sent a confirmation email to ',
  subtitle1Verify: 'We sent a verification email to ',
  subtitle2: '. Check your email and enter the verification code',
  buttonNext: 'Next',
  placeholder: {
    email: 'Email',
  },
  successSendCode: 'New code has been sent',
};
